<template>
<div class="chapter">
<div class="inner_page">
<a id="page_18"></a>
<h2 class="chap_head" id="chapter1"><span class="bold">1921–1929</span></h2>
<h3 class="sub_section"><span class="bold">1921</span></h3>
<p class="noindent">The United Counties Omnibus and Road Transport Company was formed on 24 September 1921, when the business of the Wellingborough Motor Omnibus Company Ltd. was acquired. The opening fleet comprised thirty-seven operational buses of Leyland manufacture, along with two vehicles that were under construction. Broken down, the fleet acquired was made up of twenty-nine double-deck machines and eight saloons. They retained their original Wellingborough fleet numbers of A1 to A17; B1 to B14 and S2 to S7 respectively. The two vehicles that were still being built when the takeover took place were delivered in November 1921. These vehicles were registered BD257 and BD481, numbered S8 and S9. United Counties fitted their own bodies to these two vehicles which were based on the Leyland RAF chassis, which were reconditioned chassis dating back to the First World War. The first new vehicle orders placed by the company called for twelve Leyland chassis for delivery in 1922.</p>
<p class="indent">Vehicles were garaged in the small Northamptonshire town of Irthlingborough whilst the head office was in Wellingborough. Services operated at this time were focused on the Wellingborough, Rushden, Irthlingborough, Raunds and Kettering areas, serving nearby villages, with one service reaching Northampton.</p>
<p class="indent">It is worth noting at this point that United Counties applied a fleet number to both the chassis and bodywork. These were generally allocated to the vehicles when they were taken into stock by the company, hence some vehicles being numbered out of sequence. Over the coming chapters, the chassis number is displayed first, followed by the body numbers in brackets. In the list below, the body number is shown after the chassis number.</p>
<p class="indent">The opening fleet was as follows:</p>
<table class="table1">
<tbody><tr>
<td class="tab1">A1</td>
<td class="tab2">1</td>
<td class="tab3">LN329</td>
</tr>
<tr>
<td class="tab1">A2</td>
<td class="tab2">2</td>
<td class="tab3">LF9876</td>
</tr>
<tr>
<td class="tab1">A3</td>
<td class="tab2">3</td>
<td class="tab3">LF9967</td>
</tr>
<tr>
<td class="tab1">A4</td>
<td class="tab2">4</td>
<td class="tab3">LF9969</td>
</tr>
<tr>
<td class="tab1">A5</td>
<td class="tab2">5</td>
<td class="tab3">LF9970</td>
</tr>
<tr>
<td class="tab1">A6</td>
<td class="tab2">6</td>
<td class="tab3">LH8633</td>
</tr>
<tr>
<td class="tab1">A7</td>
<td class="tab2">7</td>
<td class="tab3">LH8651</td>
</tr>
<tr>
<td class="tab1">A8</td>
<td class="tab2">8</td>
<td class="tab3">LF9877</td>
</tr>
<tr>
<td class="tab1">A9</td>
<td class="tab2">9</td>
<td class="tab3">LH8721</td>
</tr>
<tr>
<td class="tab1">A10</td>
<td class="tab2">10</td>
<td class="tab3">LH8893</td>
</tr>
<tr>
<td class="tab1">A11</td>
<td class="tab2">11</td>
<td class="tab3">LH8933</td>
</tr>
<tr>
<td class="tab1">A12</td>
<td class="tab2">12</td>
<td class="tab3">LH8934</td>
</tr>
<tr>
<td class="tab1">A13</td>
<td class="tab2">13</td>
<td class="tab3">BD3218</td>
</tr>
<tr>
<td class="tab1">A14</td>
<td class="tab2">14</td>
<td class="tab3">BD4147</td>
</tr>
<tr>
<td class="tab1">A15</td>
<td class="tab2">15</td>
<td class="tab3">BD4580</td>
</tr>
<tr>
<td class="tab1">A16</td>
<td class="tab2">16</td>
<td class="tab3">BD5049</td>
</tr>
<tr>
<td class="tab1">A17</td>
<td class="tab2">17</td>
<td class="tab3">BD5844</td>
</tr>
<tr>
<td class="tab1">S1</td>
<td class="tab2">22</td>
<td class="tab2">BD3890</td>
</tr>
<tr>
<td class="tab1">S2</td>
<td class="tab2">23</td>
<td class="tab3">BD1642</td>
</tr>
<tr>
<td class="tab1">S3</td>
<td class="tab2">24</td>
<td class="tab3">BD2038</td>
</tr>
<tr>
<td class="tab1">S4</td>
<td class="tab2">25</td>
<td class="tab3">BD3039</td>
</tr>
<tr>
<td class="tab1">S5</td>
<td class="tab2">26</td>
<td class="tab3">BD3042</td>
</tr>
<tr>
<td class="tab1">S6</td>
<td class="tab2">27</td>
<td class="tab3">BD986</td>
</tr>
<tr>
<td class="tab1">S7</td>
<td class="tab2">28</td>
<td class="tab3">BD3056</td>
</tr>
<tr>
<td class="tab1">B1</td>
<td class="tab2">31</td>
<td class="tab3">BD476</td>
</tr>
<tr>
<td class="tab1">B2</td>
<td class="tab2">32</td>
<td class="tab3">BD491</td>
</tr>
<tr>
<td class="tab1">B3</td>
<td class="tab2">33</td>
<td class="tab3">BD513</td>
</tr>
<tr>
<td class="tab1">B4</td>
<td class="tab2">34</td>
<td class="tab3">BD557</td>
</tr>
<tr>
<td class="tab1">B5</td>
<td class="tab2">35</td>
<td class="tab3">BD588</td>
</tr>
<tr>
<td class="tab1">B6</td>
<td class="tab2">36</td>
<td class="tab3">BD948</td>
</tr>
<tr>
<td class="tab1">B7</td>
<td class="tab2">37</td>
<td class="tab3">BD1128</td>
</tr>
<tr>
<td class="tab1">B8</td>
<td class="tab2">38</td>
<td class="tab3">BD1130</td>
</tr>
<tr>
<td class="tab1">B9</td>
<td class="tab2">39</td>
<td class="tab3">BD1709</td>
</tr>
<tr>
<td class="tab1">B10</td>
<td class="tab2">40</td>
<td class="tab3">BD2321</td>
</tr>
<tr>
<td class="tab1">B11</td>
<td class="tab2">41</td>
<td class="tab3">BD3488</td>
</tr>
<tr>
<td class="tab1">B12</td>
<td class="tab2">42</td>
<td class="tab3">BD3870</td>
</tr>
<tr>
<td class="tab1">B13</td>
<td class="tab2">43</td>
<td class="tab3">BD4414</td>
</tr>
<tr>
<td class="tab1">B14</td>
<td class="tab2">44</td>
<td class="tab3">BD5845</td>
</tr>
</tbody></table>
<a id="page_19"></a>
<h3 class="sub_section"><span class="bold">1922</span></h3>
<p class="noindent">Delivery of the above-mentioned order for twelve Leyland chassis was completed between February and May 1922 and were again of the Leyland RAF model. These were numbered S10 to S20 (45/6/53/47/57/54/48/55/6/8/9) in the United Counties fleet. Like the previous order, United Counties constructed their own bodywork for the first five, whilst S15-S20 were given single-deck bodies constructed by Dodson. Registration marks BD3476, 6240, 6388/9, 6676, 6391, 6390, 6392, 6499, 6500/1 were carried by these vehicles. The twelfth vehicle was numbered C1 (60) - BD7049 and was also bodied by the company. This vehicle was unique in that it was built to carry sixty passengers, a capacity that was not seen on another United Counties vehicle until the mid-1950s.</p>
<p class="indent">Three further Leyland chassis were purchased in February 1922. Two of these were bodied as lorries, whilst the third one, A20, gained a United Counties double-deck body in May 1922. Ancillary vehicle S1 donated its lorry body to one of these new chassis, in return being bodied as a double-deck bus.</p>
<p class="indent">The first second-hand vehicle to be acquired by the company entered the fleet in April 1922. BD209 originated with Luck &amp; Andrews of Kettering and was numbered B15 (49) upon entry into the fleet.</p>
<h3 class="sub_section"><span class="bold">1923</span></h3>
<p class="noindent">Vehicle orders for 1923 called for seven Leyland GH7 chassis which were ordered alongside four Dodson single-deck bodies. Rolling stock numbers C3 to C9 (63-69) were allocated to this batch. The first three were taken into stock during August 1923, the balance being delivered the following year. The four Dodson saloon bodies were fitted to C3 to C6. C3-5 were the only ones to arrive in 1923, with these vehicles being registered BD8208, 8216, 8219.</p>
<p class="indent">United Counties also purchased a former demonstration vehicle registered TC2128. The vehicle was taken into stock in May 1923 and preceded the new vehicles, being allocated rolling stock number C2 (61) by the company.</p>
<h3 class="sub_section"><span class="bold">1924</span></h3>
<p class="noindent">Other than the outstanding vehicles from 1923, no new vehicles entered the fleet during 1924. C6 was the first of these to be delivered, arriving in January registered BD8618. The remaining three, C7-9, arrived during April and were uniformly registered BD9104-6 respectively.</p>
<p class="indent">Six vehicles were rebodied during the year. B3, B4 and B10 gained new body work constructed by the company, with the bodies being donated to A2, A9 and A16.</p>
<h3 class="sub_section"><span class="bold">1925</span></h3>
<p class="noindent">A new Leyland chassis was introduced in 1925, this being the Leyland Z5. Five of this new chassis type were purchased by United Counties. Four were bodied by Dodson with twenty-seat saloon bodies and were numbered Z2-5 (72-75) – RP457/8, 580, 674. The other example, numbered Z1 (71) – RP976, was the first saloon body to be constructed by United Counties themselves.</p>
<p class="indent"><a id="page_20"></a>A further six new vehicles entered the United Counties fleet in August; the company ordered six Leyland C7 chassis along with an equal number of Dodson single-deck bodies. Fitted with pneumatic tyres, these vehicles were numbered D1-D6 (76-81) by the company and carried registrations RP1540-5.</p>
<p class="indent">The re-bodying of older vehicles in the fleet continued during 1925 when United Counties built two bodies and mounted them on to chassis A3 and A15, the two vehicles being re-registered to RP977 and RP978 respectively. At the same time, the body and registration (BD4580) from A15 was transferred to the chassis of A7.</p>
<h3 class="sub_section"><span class="bold">1926</span></h3>
<p class="noindent">Vehicle orders for 1926 called for six Leyland chassis. However, eight Leyland chassis were delivered to United Counties over the course of 1926. The original order for six materialised in May and June 1926 numbered C10-15 (85-90) and were built on the Leyland SG11 model. These vehicles gained bodywork by Dodson and were registered RP2789/7, 2864-7. The two additional chassis were again built by Leyland, this time the SG7 model. These two were numbered B16 and B17 (83/4) by the company. United Counties constructed the two double-deck bodies fitted to these machines. Registrations RP2710 and RP2788 were allotted to B16 and B17.</p>
<p class="indent">A further three older vehicles in the fleet were treated to a re-body. First was double-deck A13 which had a new single-deck body fitted. However, unlike similar vehicles already in stock, United Counties did not build the body for this vehicle; instead a new Dodson saloon body was purchased and mounted on the chassis. Sister vehicle A14 had its original saloon body replaced by one built by United Counties. The final vehicle to be treated to a re-body during 1926 was single-deck S2, which was converted from a single-deck vehicle to a double-deck machine.</p>
<h3 class="sub_section"><span class="bold">1927</span></h3>
<p class="noindent">1927 saw a large batch of eighteen single-deck vehicles delivered to the company. This introduced the Leyland Lion chassis to the fleet. They were appropriately allocated rolling stock numbers L1-18 (97-123). The Leyland Lion itself was one of the earliest buses that was specifically designed for passenger-carrying purposes. The first six, L1-6 – RP4520-2, 4633-5, carried Dodson bodies, whilst the remainder of the batch were bodied by Shorts of Rochester under contract to Leyland Motors Ltd. After the introduction of this batch of vehicles, the fleet total stood at 97 vehicles. L7-18 were registered RP5003-8, 5190/1, RP5202/3/5 and RP5236.</p>
<p class="indent">A further nine vehicles were placed through the re-bodying programme during 1927. A2/4/5/7/11/12 and B15 were rebodied using United Counties own-built bus bodies. The final two, S3 and S4, had their original Hora saloon bodies replaced with United Counties built double-deck bodies.</p>
<h3 class="sub_section"><span class="bold">1928</span></h3>
<p class="noindent">1928 saw three independent operators purchased by United Counties. The first company concerned was that of Desborough-based Summerly Bros. The acquisition <a id="page_21"></a>included a pair of Lancia single-deck vehicles, which became numbered LA1/2 (114/5) in the United Counties fleet, carrying registrations RP264, 4091.</p>
<p class="indent">One of the most important acquisitions made by United Counties was of the Northampton Omnibus Co. Ltd. The takeover allowed United Counties to expand its operating territory to the south, north and west of the town. In order for the company to be able to operate the newly acquired services, a fleet of twenty-five Leyland Lion saloons were soon purchased. These vehicles followed on from the original batch, being numbered L19-L43 (127-151) and were all bodied by Shorts, seating thirty-five passengers. The first twelve materialised in May; the next four in June and the remaining nine in July. These vehicles were registered RP5970-81, 6104/2/3, 6156, 6196/7, 6225-8, 6242/4/3.</p>
<p class="indent">Five of the original Northampton Omnibus vehicles were taken into stock by United Counties, all in the form of Daimler Y machines; two carrying Strachan bodies, two with Grose bodywork and the final one a Brown body. These vehicles were allocated body numbers 116-120 by the company, but no chassis numbers were allocated. These lasted only a few months, being displaced by a batch of Leyland Lion saloons mentioned below. Various registration plates were carried, NH4819, XF9423, NH6327, 5618 and 5423.</p>
<p class="indent">The final operator to be acquired was A.J. and A. York of Irchester in July. Included in this sale was a two-year-old 20-seat Thornycroft A1 saloon bus registered RP2138, and numbered T1 (126) by United Counties. This acquisition allowed United Counties to increase its services between the village and near-by Wellingborough.</p>
<p class="indent">During 1928, thirteen Leyland Lion saloons were purchased by United Counties. However, not all arrived during 1928, with delivery being completed in January 1929. Seven were delivered to the company in December numbered L44-51 (152-159) – RP6715-22. These carried body work constructed by Short, similar to previous deliveries of the type. They displaced a similar number of older vehicles from the fleet.</p>
<h3 class="sub_section"><span class="bold">1929</span></h3>
<p class="noindent">The outstanding Leyland Lions arrived during January, numbered L52-6 (160-4), registered RP6723-6, 6805. The first three were again bodied by Short, whilst the final pair were bodied by Leyland. In addition to these outstanding vehicles, a further twenty-two were ordered for 1929 delivery. The batch was numbered L57 to L78 (165-186) and all carried thirty-five-seat rear-entrance Leyland bodies. Delivery of this sizeable batch was spread between January and March 1929 respectively, registered RP6806-8, 6861, 6913/4, 6946-9, 7114-25. The influx of these new vehicles saw the withdrawal of seventeen older vehicles; ten A-type saloons; an S-type saloon and six double-deck machines.</p>
<p class="indent">A solitary vehicle was acquired from Desborough-based independent Crick &amp; Compton, when the company was acquired by United Counties in December 1929. The vehicle in question was a Reo saloon which seated eighteen. Registered RP1192, it was allotted fleet number 190. This small vehicle did not last long with United Counties and was withdrawn the following year.</p>
<p class="indent">United Counties took on loan a Leyland Titan demonstration vehicle from Leyland Motors Ltd. This vehicle carried a 51-seat Leyland body and was numbered TN1 (191) - TE9626 by United Counties. The vehicle remained on loan for a three-month period before being officially acquired by the company in January 1930. This led to the order of eight similar vehicles for 1930 delivery.</p>
<div class="img_container"><a id="page_22"></a><img alt="images" src="images/f0022-01.jpg"/>
<p class="caption"><span class="bold">Irthlingborough Cross</span> finds Leyland ST LF9876 in May 1913. This vehicle was one of the first to operate with the Wellingborough Motor Omnibus Company Limited. Originally numbered C, it later gained fleet number A2. It passed to United Counties in 1921. <em class="italic">Roger Warwick Collection</em></p>
</div>
<div class="img_container"><img alt="images" src="images/f0022-02.jpg"/>
<p class="caption"><span class="bold">Another shot</span> here of LF9967 which featured in the introduction. It is seen standing at the George and Dragon, Raunds, in this 1914 shot. The vehicle originally carried the letter H, later being renumbered to A3. It clearly shows the Birch body style, built on the Leyland 36HP chassis. <em class="italic">Roger Warwick Collection</em></p>
</div>
<div class="img_container"><a id="page_23"></a><img alt="images" src="images/f0023-01.jpg"/>
<p class="caption"><span class="bold">The original</span> garage for the Wellingborough Motor Omnibus Company Limited was located in the small Northamptonshire town of Irthlingborough. This photograph shows Leyland ST A4 (LF9969) leaving the garage in January 1914. This was another vehicle acquired by United Counties in 1921. <em class="italic">Roger Warwick Collection</em></p>
</div>
<div class="img_container"><img alt="images" src="images/f0023-02.jpg"/>
<p class="caption"><span class="bold">Representing the</span> small number of single-deck vehicles acquired from WMOC is LH8934. This vehicle took up rolling stock number A12 and is another example of the Leyland ST model. It is seen passing through Broughton destined for Northampton, contrary to the destination board. <em class="italic">Roger Warwick Collection</em></p>
</div>
<div class="img_container"><a id="page_24"></a><img alt="images" src="images/f0024-01.jpg"/>
<p class="caption"><span class="bold">The George</span> and Dragon, Raunds, provides the backdrop to Leyland 36HP B9 (BD1709). This vehicle was new to the Wellingborough Motor Omnibus Company in July 1919, the same year that this photograph was taken. BD1709 was one of a number of vehicles to pass to United Counties in 1921. <em class="italic">Roger Warwick Collection</em></p>
</div>
<div class="img_container"><img alt="images" src="images/f0024-02.jpg"/>
<p class="caption"><span class="bold">During the</span> early 1920s, United Counties Omnibus and Road Transport Co. Ltd took stock of a number of Leyland RAF chassis. S10 – BD3476 was new in February 1922 and is seen carrying a body constructed by United Counties themselves. <em class="italic">Roger Warwick Collection</em></p>
</div>
<div class="img_container"><a id="page_25"></a><img alt="images" src="images/f0025-01.jpg"/>
<p class="caption"><span class="bold">The Leyland</span> Lion was the first significant type of single-decker taken into stock by United Counties. Eighty-nine were purchased by the company between 1927 and 1930, and all gained fleet numbers beginning with ‘L’. Here we see two fine examples of the type, L68 – RP7115</p>
</div>
<div class="img_container"><img alt="images" src="images/f0025-02.jpg"/>
<p class="caption">L73 – RP7120 They are both photographed at Skegness whilst on private hire duties. <em class="italic">G. H. F. Atkins Archive/S. J. Butler Collection</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Chapter_1.vue?46057e3a